import { render, staticRenderFns } from "./HeaderSocials.vue?vue&type=template&id=02d2c634&lang=pug&"
import script from "./HeaderSocials.vue?vue&type=script&lang=js&"
export * from "./HeaderSocials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports